import { Pipe, PipeTransform } from '@angular/core';
import {InvoiceRequestActions} from "../models/entities/invoice-actions";

@Pipe({
  name: 'invoiceActionsName'
})
export class InvoiceActionsNamePipe implements PipeTransform {
  transform(action: InvoiceRequestActions): string | null {
    switch (action) {
      case InvoiceRequestActions.validate: {
        return 'Valider';
      }
      default: {
        return null;
      }
    }
  }
}
